<script setup lang="ts">
// types
import type { SectionFaqMultipleProps } from '@ts-sections/section-faq-multiple/interfaces'
// hooks
import { useSectionFaqMultiple } from '@hooks/sections/section-faq-multiple.hook'
// components
import { AppText } from '@UI/Typography/AppText'
import BlockFaqGroup from '@Blocks/BlockFaqGroup.vue'
import BlockFaqCategories from '@Blocks/BlockFaqCategories.vue'

defineOptions({
  name: 'SectionFaqMultiple',
})

const props = defineProps<{
  section: SectionFaqMultipleProps
}>()

const {
  refGroups,
  refCategories,
  refActiveIndex,
  handleSelectCategory,
} = useSectionFaqMultiple({
  section: () => props.section,
})
</script>

<template>
  <section
    v-if="refGroups.length"
    class="section-faq-multiple"
    :data-component="section.__component"
  >
    <AppText
      v-if="section.title"
      tag="h2"
      :name="{ base: 'h4', 740: 'h3' }"
      color="slate-900"
      class="section-faq-multiple__title"
    >
      {{ section.title }}
    </AppText>

    <div class="section-faq-multiple__layout">
      <BlockFaqCategories
        class="section-faq-multiple__categories"
        :categories="refCategories"
        :active-index="refActiveIndex"
        @click:select="handleSelectCategory"
      />

      <div class="section-faq-multiple__accordion">
        <BlockFaqGroup
          v-for="(group, index) in refGroups"
          v-show="index === refActiveIndex"
          :key="group.id ?? index"
          :group="group"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss" src="@scss/components/Sections/SectionFaqMultiple.scss" />
